function hideAlternateOption(metal) {
    if (metal != 'gold') {
        $('#gold-metal-account-slider').removeClass('in');
    }
    if (metal != 'silver') {
        $('#silver-metal-account-slider').removeClass('in');
    }
    if (metal != 'allocated_gold') {
        $('#allocated_gold-metal-account-slider').removeClass('in');
    }
    if (metal != 'allocated_silver') {
        $('#allocated_silver-metal-account-slider').removeClass('in');
    }

    if (metal.indexOf('allocated_') >= 0) {
        $('#digit_aul_saving').hide();
    } else {
        $('#digit_aul_storage').hide();
    }
}

export {hideAlternateOption}